const ctaHandler = () => {
    const ctaTile = document.querySelector('.tile.cta').cloneNode(true);
    const ctaTile2 = document.querySelector('.tile.cta:nth-of-type(2)');
    console.log(ctaTile2);
  
    const cloneAndAppend = (cta, index) => {
      $(cta).clone().insertAfter(`.tile:not(.filter):not(.cta):nth-of-type(${index})`);
    };
  
    const appendCTAInPlace = (originalCTA, secondCTA) => {
      $('.tile.cta').remove();
  
      const initialPositionFirstCTA = 4;
      const initialPositionSecondCTA = 12;
      let repeatEveryFirstCTA = 20; //eslint-disable-line
      let repeatEverySecondCTA = 28; //eslint-disable-line
      const visibleTiles = [];
      const allTiles = Array.from(document.querySelectorAll('.tile:not(.filter):not(.cta)'));
      
      allTiles.forEach(function findVisibleTiles(tile, index) {
        if (tile.style.display !== 'none') {
          visibleTiles.push(index); 
        }
      });
      
      visibleTiles.forEach(function appendCTAInPosition(tileIndex, arrayIndex) {
        // function is modded to accept two ctas and reorder streams, filtered or not accordingly
        if (arrayIndex === initialPositionFirstCTA) {
          cloneAndAppend(originalCTA, tileIndex);
        } else if (arrayIndex === initialPositionSecondCTA) {
            cloneAndAppend(secondCTA, tileIndex);
        } else if (arrayIndex === repeatEveryFirstCTA) {
          repeatEveryFirstCTA += 16; //eslint-disable-line
          cloneAndAppend(originalCTA, tileIndex);
        } else if (arrayIndex === repeatEverySecondCTA) {
          repeatEverySecondCTA += 16;
          cloneAndAppend(secondCTA, tileIndex);
        } else if (arrayIndex === visibleTiles.length - 1 && visibleTiles.length < 5) {
            //this ensures that if filtered tiles are less than 5, then they will only show one tile in the final spot
            cloneAndAppend(originalCTA, tileIndex + 1);
        } else if (arrayIndex === visibleTiles.length - 1 && visibleTiles.length < 12) {
            cloneAndAppend(secondCTA, tileIndex + 1);
        }
      });
  
      $('.tile.cta').show();
    };
  
    const sortAndOrderListener = (ctaTile) => {
      
      const sortAndOrderToggler = $('#sorting-container__form');
      sortAndOrderToggler.on('change', () => {
        appendCTAInPlace(ctaTile, ctaTile2);
      });
  
      const filterToggler = $('onBrand__filter--form');
      filterToggler.on('change', () => {
        appendCTAInPlace(ctaTile, ctaTile2);
      });
    };
  
    const ctaInit = () => {
      appendCTAInPlace(ctaTile, ctaTile2);
      sortAndOrderListener(ctaTile);
    };
  
    ctaInit();
  };
  
  module.exports.ctaInit = ctaHandler;


// WEBPACK FOOTER //
// ./custom-js/ctaHandler.js